export enum ECases {
  OWN_CASE = 2,
  CHILD_CASE = 3,
  OTHER_PERSON_CASE = 4,
}
